export default "__VITE_ASSET__c83eb9d1__"